/* SleepOn · animaciones: aparición al hacer scroll (escalonada) y contadores de cifras. Sin dependencias. */
(function () {
  if (window.__soAnim) return; window.__soAnim = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = '.so .so-h2,.so .so-lead,.so-icons>div,.so-nc,.so-prod,.so-st,.so-tl>div,.so-cmp,.so-rv,.so-gu,.so-of,.so-fq,.so-feel img,.so-fl>div,.so-vs,.so-tried span,.so-rd,.so-ugc,.so-rvh,.so-row,.so-how__steps>div,.so-vs2__c,.so-vs2__badge,.so-ba figure,.so-ba__q,.so-hl,.so-exp__q';

  function count(el) {
    var raw = el.getAttribute('data-so-count') || el.textContent.trim();
    var m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/); if (!m) return;
    var pre = m[1], num = m[2], post = m[3];
    var dec = num.indexOf(',') > -1 && !/\.\d{3}/.test(num) ? ',' : null;          // "4,8" decimal; "35.000" miles
    var val = parseFloat(dec ? num.replace(',', '.') : num.replace(/\./g, ''));
    var digits = dec ? (num.split(',')[1] || '').length : 0;
    var t0 = null, dur = 1400;
    function fmt(v) {
      if (dec) return v.toFixed(digits).replace('.', ',');
      var s = Math.round(v).toString(); return num.indexOf('.') > -1 ? s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : s;
    }
    function step(ts) {
      if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + fmt(val * e) + post; if (p < 1) requestAnimationFrame(step);
    }
    el.setAttribute('data-so-count', raw); requestAnimationFrame(step);
  }

  function fadeSections() {
    // umbral 0: las secciones muy altas (p. ej. reseñas) también aparecen
    var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('so-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });
    document.querySelectorAll('main .shopify-section').forEach(function (sec, i) {
      if (i === 0 || sec.querySelector('.so') || sec.classList.contains('so-fade') || sec.id.indexOf('main') > -1) return;
      var r = sec.getBoundingClientRect(); if (r.top < window.innerHeight) return;   // lo visible al cargar no se oculta
      sec.classList.add('so-fade'); io.observe(sec);
    });
  }
  function init(root) {
    var els = (root || document).querySelectorAll(SEL);
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        el.classList.add('so-in');
        el.querySelectorAll && el.querySelectorAll('[data-so-num]').forEach(count);
        if (el.matches && el.matches('[data-so-num]')) count(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    if (!root) fadeSections();
    els.forEach(function (el) {
      if (el.classList.contains('so-rv-ready')) return;
      el.classList.add('so-rv-ready');
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = Math.min(sib, 6) * 70 + 'ms';
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
